/**
 * Thin wrapper that mounts ReportsTabCN scoped to the current location.
 *
 * Linear: MYD-340 (Phase 3).
 */

import { useParams } from 'react-router-dom'
import ReportsTabCN from 'features/Reports/ReportsTabCN'

const LocationReports = () => {
	const { id } = useParams<{ id: string }>()
	if (!id) return null
	return (
		<ReportsTabCN
			scope="location"
			entityId={id}
			heading="Location reports"
			subhead="Generate a one-page Brief for site-selection pitches, or a multi-page Story for due-diligence packages. Reports land here and on the Documents tab."
		/>
	)
}

export default LocationReports
